@if (treeDataSig()?.length > 0) {
  <p-treeTable
    [value]="treeDataSig()"
    [columns]="config().tableHeader"
    [paginator]="hasPaginator()"
    [sortOrder]="config().sortOrder"
    [sortField]="config().sortField ? config().sortField : ''"
    [scrollable]="config().scrollable"
    [tableStyle]="config().style"
    (onNodeExpand)="onNodeExpand($event)"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        @for (col of columns; track col.field) {
          <th [ttSortableColumn]="col.sortable ? col.field : null" [class]="col.class ? col.class : ''">
            {{ col.header | translate }}
            @if (col.sortable) {
              <p-treeTableSortIcon [field]="col.field" tabindex="-1" />
            }
          </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns" let-rowIndex="rowIndex">
      <tr [ttRow]="rowNode">
        @for (col of columns; track col.field; let i = $index) {
          <td class="tree-node-cell">
            <div class="tree-node-wrapper">
              @if (rowNode.level > 0) {
                <div class="tree-lines">
                  @for (levelState of getLevels(rowNode); let isLast = $last; track levelState.level) {
                    <div class="tree-line-vertical" [class.last]="isLast" [class.continue]="levelState.continue"></div>
                    @if (isLast) {
                      <div class="tree-line-horizontal"></div>
                    }
                  }
                </div>
              }
              @if (i === 0) {
                <div class="tree-node-content" [style.padding-left.px]="rowNode.level * 20" tabindex="0">
                  @if (rowNode.node.loading) {
                    <p-progressSpinner class="plyca-ui-tree-spinner" />
                  } @else {
                    <p-treeTableToggler [rowNode]="rowNode" class="custom-toggler" />
                    <i [class]="rowNode.node.expanded ? rowNode.node.expandedIcon : rowNode.node.collapsedIcon"></i>
                  }
                  @if (rowNode.node.icon && !rowNode.node.loading) {
                    <i [class]="rowNode.node.icon"></i>
                  }
                  <span class="tree-node-content--title">{{ rowNode.node.label }}</span>
                </div>
              } @else {
                <span>{{ rowData[col.field] }}</span>
              }
            </div>
          </td>
        }
        @if (config().hasActions) {
          <ng-container *ngTemplateOutlet="tableTemplateBody; context: { $implicit: rowNode, rowIndex: rowIndex }"></ng-container>
        }
      </tr>
    </ng-template>
  </p-treeTable>
}
